export const listLlmOverridesConfig = () => ({
  url: `/v2/llm_overrides`,
});

export const updateLlmOverridesConfig = () => ({
  url: `/v2/llm_overrides`,
});
